// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2tgSi","actionsCol":"EnrolledClinics_actionsCol__2Ofiw"};